export const advanceSimulationKey = "advanceSimulation";
export const standingsKey = "standings";
export const registeredStudentsKey = "registeredStudents";
export const backKey = "back";
